import { downloadFile } from "@elit-hair/elit-tools";
import { TFunction } from "i18next";
import { enqueueSnackbar } from "notistack";

import { ExportTypes } from "@/types/export.types";

export const downloadImage = async (imageUrl: string) => {
    try {
        const res = await fetch(imageUrl);
        const blob = await res.blob();
        download(blob, imageUrl.slice(imageUrl.lastIndexOf("/") + 1));
    } catch (err) {
        console.error(err, "err");
    }
};

const download = (blob: Blob, name: string) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (!reader.result) return;
            const a = document.createElement("a");
            a.href = reader.result as string;
            a.className = "!d-none";

            a.download = name || "custom-file";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            resolve(true);
        };
        reader.onerror = () => reject();
        reader.readAsDataURL(blob);
    });

export const downloadAsExcel = async (file: ArrayBuffer, format: ExportTypes, name: string) => {
    const type = format == ExportTypes.CSV ? "text/csv" : "application/vnd.ms-excel";
    const blob = new Blob([file], { type });

    await download(blob, name + ("." + format));
};

export const downloadUetdsPdf = async (url: string | undefined | null, id: string, t: TFunction) => {
    {
        if (!url) return;
        try {
            await downloadFile(url, `UETDS-${id}`, true);
            enqueueSnackbar(t("responses.downloadSuccess"), {
                variant: "success",
            });
        } catch (err) {
            enqueueSnackbar(t("responses.downloadFailed"), {
                variant: "error",
            });
        }
    }
};
